import React from "react";
import PropTypes from "prop-types";
import { Row, Radio } from "antd";
import { getScheduleVal } from "../../../utils/report";

export const weekSetValueHandler = (value, record) => {
  let val2 = getScheduleVal(record, 2);
  if (val2 === undefined) {
    val2 = "Monday";
  }
  let month = getScheduleVal(record, 3);
  if (month === undefined) {
    month = "1";
  }
  return record.shedule_type == "Monthly"
    ? `${value}_${val2}`
    : `${month}_${value}_${val2}`;
};

export const daySetValueHandler = (value, record) => {
  let val1 = getScheduleVal(record, 1);
  if (val1 === undefined) {
    val1 = 1;
  }
  let month = getScheduleVal(record, 3);
  if (month === undefined) {
    month = "1";
  }
  return record.shedule_type == "Monthly"
    ? `${val1}_${value}`
    : `${month}_${val1}_${value}`;
};

export const WeekOfMonth = (props) => {
  const { week, changeWeekHandler, day, changeDayHandler } = props;
  return (
    <>
      <Row justify="center">
        <Radio.Group
          value={week}
          buttonStyle="solid"
          onChange={changeWeekHandler}
        >
          <Radio.Button value="1">Week 1</Radio.Button>
          <Radio.Button value="2">Week 2</Radio.Button>
          <Radio.Button value="3">Week 3</Radio.Button>
          <Radio.Button value="4">Week 4</Radio.Button>
        </Radio.Group>
      </Row>
      <Row justify="center">
        <Radio.Group value={day} name="radiogroup" onChange={changeDayHandler}>
          <Radio value="Monday">M</Radio>
          <Radio value="Tuesday">T</Radio>
          <Radio value="Wednesday">W</Radio>
          <Radio value="Thursday">T</Radio>
          <Radio value="Friday">F</Radio>
          <Radio value="Saturday">S</Radio>
          <Radio value="Sunday">S</Radio>
        </Radio.Group>
      </Row>
    </>
  );
};

WeekOfMonth.propTypes = {};

export default WeekOfMonth;
